<template>

<v-dialog v-model="dialog" width="1000px">
  <v-card>
    <p class=".title ma-2">Add a sentence to {{hszn.huis_code }} </p>
    <v-form ref="addHszn" v-model="addHsznValid">
     <!--
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-text-field v-model="hszn.eign_code" :rules="eign_codeRules" label="Host ID"></v-text-field>
      </v-col>
     </v-row>  
      -->
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="hszn.zinn_nr" @input="runStep2()" required :items="zinn_nrKeuzes" item-value="zinn_nr" item-text="zinntaal_oms" label="Sentence" dense :rules="zinn_nrRules"></v-select>
      </v-col>
     </v-row>  

      <v-row v-if="hszn.zinn_nr > 0 && zinn.var1 == 'Yes'" no-gutters>
         <v-col class="ma-2">
           <v-text-field v-model="hszn_val1" label="Variable 1" :rules="zinn_valRules"></v-text-field>
         </v-col>
      </v-row>

      <v-row v-if="hszn.zinn_nr > 0 && zinn.var2 == 'Yes'" no-gutters>  
         <v-col class="ma-2">
           <v-text-field v-model="hszn_val2" label="Variable 2" :rules="zinn_valRules"></v-text-field>
         </v-col>
      </v-row>    

      <v-row v-if="hszn.zinn_nr > 0 && zinn.var3 == 'Yes'" no-gutters>  
         <v-col class="ma-2">
           <v-text-field v-model="hszn_val3" label="Variable 3" :rules="zinn_valRules"></v-text-field>
         </v-col>
      </v-row>

      <v-row v-if="hszn.zinn_nr > 0 && zinn.var4 == 'Yes'" no-gutters>  
         <v-col class="ma-2">
           <v-text-field v-model="hszn_val4" label="Variable 4" :rules="zinn_valRules"></v-text-field>
         </v-col>
      </v-row>
    
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHszn" :disabled="!addHsznValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

// import {bus} from "../../../main";

export default {
  data() { 
    return {
      dialog: false,
      addHsznValid: false,
      huis_encrid: null,
      zinn_nrKeuzes: [],
      hszn: {},
      zinn: {},
      hszn_val1: null,
      hszn_val2: null,
      hszn_val3: null,
      hszn_val4: null,
      zinn_nrRules: [
          v => !!v || "A Sentence is required"
      ],
      zinn_valRules: [
          v => !!v || "A value is required"
      ] 
    }
  },
  methods: {
    open(huis_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hszn/getHuisToAddHszn.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToAddHszn"
          },
          getHuisToAddHszn: {
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hszn = res.data.getHuisToAddHszn;
            res.data.getHuisToAddHszn.zinn_nrKeuzes.forEach(function(zinn) {
            deze.zinn_nrKeuzes.push(zinn); 
           });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    runStep2() {
      this.$axios
        .post("ares/json/ares/huis/hszn/getZinnToAddHszn.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getZinnToAddHszn"
          },
          getZinnToAddHszn: {
            huis_encrid: this.hszn.huis_encrid,
            zinn_nr: parseInt(this.hszn.zinn_nr)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.zinn = res.data.getZinnToAddHszn;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addHszn() { 
      this.$axios
        .post("ares/json/ares/huis/hszn/addHszn.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addHszn"
          },
          addHszn: {
            huis_encrid: this.hszn.huis_encrid,
            zinn_nr: this.hszn.zinn_nr,
            hszn_val1 : this.hszn_val1,
            hszn_val2 : this.hszn_val2,
            hszn_val3 : this.hszn_val3,
            hszn_val4 : this.hszn_val4
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            // if (res.data.addHszn.color == "success")
            //    //this.$router.reload('/huis/onHuis/' + res.data.addHszn.huis_encrid);
            //    bus.$emit("closeDialog", "reload");
            // else {               
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addHszn.text,
              color: res.data.addHszn.color
            }); 
            this.$emit('updateData');
          //  }  
            this.dialog = false;
          }
        })
    }
  }
}
</script>

